import React from 'react';
import moment from 'moment';
import swal from "sweetalert";
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { connect } from 'react-redux';
import Loader from "../../../components/ui/Loader/Loader";
import { toast } from 'react-toastify';
import tapIcon from "../../../services/TapIcon";
import Ax from "../../../components/hoc/Ax";
import { INVENTORY_API_BASE_URL_2, ISC_INV_TRANSFER_URL } from '../../../services/TapApiUrls';
import HttpAPICall from '../../../services/HttpAPICall';
import { DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom } from '../../../components/TapUi';
import Status from '../../../components/ui/Status';
import { Helmet } from 'react-helmet';
import TapSelect from '../../../components/ui/TapSelect';
import download from '../../../services/DownloadFile';
import AppBaseComponent from '../../../components/AppBaseComponent';
import { Modal } from 'bootstrap';
import InputItemSearch from '../../includes/ui/InputItemSearch';
import CurrencyFormatter from '../../../services/CurrencyFormatter';
import TapHelper from '../../../services/TapHelper';
import InventoryTransferDetail from './InventoryTransferDetail';

class InventoryTransferList extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.initInventorySearchForm = {
            search_like_transaction_id: '',
            search_eway_number: '',
            search_invoice_number: '',
            search_item_batch_number: '',
            search_item_ids: [],
            search_warehouse_from_ids: [],
            search_warehouse_to_ids: [],
            search_item_tags: [],
            search_status_ids: [],
            date_range: null,
            date_range_start: null,
            date_range_end: null,
        }

        this.inventorySearchFormLabel = {
            search_like_transaction_id: 'Transaction ID : ',
            search_eway_number: 'Eway Number : ',
            search_invoice_number: 'Invoice Number : ',
            search_item_batch_number: 'Batch Number : ',
            search_item_ids: 'Items : ',
            search_warehouse_from_ids: 'Dispatching Warehouse : ',
            search_warehouse_to_ids: 'Receiving Warehouse : ',
            search_item_tags: 'Item Tags : ',
            search_status_ids: 'Search Status : ',
            date_range: 'Date Range : ',
        }

        this.state = {
            minimizeTable: false,
            listing_loading: false,
            listing_tbl_page: 1,
            inventory_listing: [],
            listingMeta: null,
            totalListingCount: 0,
            inventoryItemId: null,
            inventoryDetail: null,
            searchedItem: [],
            inventorySearchForm: { ...this.initInventorySearchForm },
            submittedInventoryFilterForm: { ...this.initInventorySearchForm },
            formSearchedElems: [],
            pdfDownloading: false,
            all_warehouses: [],
            allDispatchingWarehouses: [],
            allReceivingWarehouses: [],
            allStatusOptions: [],
            allItemTags: [],
            all_periods: [],
            criteriaHeight: 0,
        };

        this.criteriaRef = React.createRef();
        this.inventoryDetailRef = React.createRef();

        this.inventoryTransferUrl = ISC_INV_TRANSFER_URL;
        this.inventoryTransferListUrl = INVENTORY_API_BASE_URL_2 + '/inventory_transfers';
        this.inventoryTransferReportUrl = INVENTORY_API_BASE_URL_2 + '/report/item-wise-inventory-tranfer';
    }

    componentDidMount() {
        this.initializeData(this.props);
        if (this.props.location && this.props.location.state && this.props.location.state.inventoryId) {
            this.viewInventoryTransferDetail(this.props.location.state.inventoryId);
        }
        this.inventorySearchModal = new Modal(document.getElementById('inventorySearchModal'), { keyboard: false, backdrop: false });
    }

    updateCriteriaHeight = () => {
        if (this.criteriaRef.current) {
            const height = this.criteriaRef.current.offsetHeight;
            if (this.state.criteriaHeight !== height) {
                this.setState({ criteriaHeight: height });
            }
        }
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.formSearchedElems !== this.state.formSearchedElems) {
            setTimeout(() => {
                this.updateCriteriaHeight();
            }, 1000);
        }
        if (this.props.location.search !== prevProps.location.search) {
            const { search } = this.props.location;
            const searchParams = new URLSearchParams(search);
            const searchText = TapHelper.sanitizeObject(searchParams.get('searchText'));
            if (searchText) {
                this.setState(prevState => ({
                    inventorySearchForm: {
                        ...prevState.inventorySearchForm,
                        search_like_transaction_id: searchText
                    }
                }), () => {
                    this.submitInventorySearchForm();
                });
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.all_periods !== this.props.all_periods) {
            this.initializeData(nextProps);
        }
        let ParamObject = new URLSearchParams(this.props.location.search);
        if (ParamObject.get('search_id')) {
            let id = ParamObject.get('search_id');
            this.viewInventoryTransferDetail(id);
        }
    }

    initializeData = (pr) => {
        if (pr) {
            let all_periods = [...pr.all_periods, { key: 'custom', display: 'Custom Date Range' }];

            this.setState({ listing_loading: true });
            
            HttpAPICall.withAthorization('GET', this.inventoryTransferUrl + '/add_form_data', pr.access_token, null, null, (response) => {
                let formData = response.data;
                this.setState({
                    formDataLoaded: formData ? true : false,
                    all_periods: all_periods,
                    allItemTags: pr.item_tags && pr.item_tags.length > 0 ? pr.item_tags.map((s) => { return { value: s.id, label: s.name }; }) : [],
                    allDispatchingWarehouses: pr.all_warehouses ? pr.all_warehouses.map((s) => { return { value: s.id, label: s.name, site_id: s.site_id }; }) : [],
                    allReceivingWarehouses: formData && formData.warehouses ? formData.warehouses.map((s) => { return { value: s.id, label: s.name, site_id: s.site_id }; }) : [],
                    allStatusOptions: formData && formData.status ? formData.status.map((s) => { return { value: s.key, label: s.status } }) : [],
                });
            }).then(() => {
                let ParamObject = new URLSearchParams(this.props.location.search);
                const { search } = this.props.location;
                const searchParams = new URLSearchParams(search);
                const searchText = TapHelper.sanitizeObject(searchParams.get('searchText'));
                if (ParamObject.get('transaction_id')) {
                    this.setState({
                        inventorySearchForm: {
                            ...this.state.inventorySearchForm,
                            search_like_transaction_id: ParamObject.get('transaction_id')
                        }
                    }, () => {
                        this.submitInventorySearchForm();
                    });
                } else if (searchText) {
                    this.setState(prevState => ({
                        inventorySearchForm: {
                            ...prevState.inventorySearchForm,
                            search_like_transaction_id: searchText
                        }
                    }), () => {
                        this.submitInventorySearchForm();
                    });
                } else {
                    this.loadListingTblData(1);
                }
            });
        }
    }

    //************************GET LISTING**************** */
    loadListingTblData = (page = 1) => {
        this.setState({ listing_loading: true, listing_tbl_page: page });
        let params = { ...this.state.submittedInventoryFilterForm, page: page };
        HttpAPICall.withAthorization('GET', this.inventoryTransferListUrl, this.props.access_token, params, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                inventory_listing: respData.data,
                listingMeta: respData.meta,
                totalListingCount: respData.meta.total,
            });
        }).then(() => this.setState({ listing_loading: false }));
    }

    openAddInventoryTransferScreen = () => {
        this.props.history.push('/inventory_transfer_list/add');
    }

    viewInventoryTransferDetail = (transaction_id) => {
        this.setState({ 
            minimizeTable: true,
            inventoryItemId: transaction_id 
        });
        if (this.inventoryDetailRef.current) {
            this.inventoryDetailRef.current.getInventoryTransferDetail(transaction_id);
        }
    }

    inventorySearchModalInit = () => {
        this.inventorySearchModal.show();
    }

    submitInventorySearchForm = (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        let serachFormKeys = Object.keys(this.state.inventorySearchForm);
        let searchedElems = [];
        let searchParams = {};
        serachFormKeys.map((key) => {
            let label = this.inventorySearchFormLabel[key];
            let value = this.state.inventorySearchForm[key];
            if (value && value.length > 0) {
                searchParams[key] = value;
                if (label) {
                    let show_val = value;
                    if (key == 'search_like_transaction_id') {
                        show_val = this.state.inventorySearchForm ? this.state.inventorySearchForm.search_like_transaction_id : '';
                    }
                    if (key == 'search_invoice_number') {
                        show_val = this.state.inventorySearchForm ? this.state.inventorySearchForm.search_invoice_number : '';
                    }
                    if (key == 'search_item_batch_number') {
                        show_val = this.state.inventorySearchForm ? this.state.inventorySearchForm.search_item_batch_number : '';
                    }
                    if (key == 'search_eway_number') {
                        show_val = this.state.inventorySearchForm ? this.state.inventorySearchForm.search_eway_number : '';
                    }
                    if (key == 'search_item_ids') {
                        show_val = this.state.searchedItem ? this.state.searchedItem.map(s => s.display_label).join(', ') : '';
                    }
                    if (key == 'search_warehouse_from_ids') {
                        show_val = this.state.allDispatchingWarehouses.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if (key == 'search_warehouse_to_ids') {
                        show_val = this.state.allReceivingWarehouses.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if (key == 'search_item_tags') {
                        show_val = this.state.allItemTags.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if (key == 'search_status_ids') {
                        show_val = this.state.allStatusOptions.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if (key == 'date_range') {
                        let start_range = moment(this.state.inventorySearchForm.date_range_start).format('DD-MMM-YYYY');
                        let end_range = moment(this.state.inventorySearchForm.date_range_end).format('DD-MMM-YYYY');
                        let display_custom = `Custom Date Range (${start_range} - ${end_range})`;
                        show_val = this.state.all_periods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
                    }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        this.setState({
            submittedInventoryFilterForm: { ...this.state.inventorySearchForm },
            formSearchedElems: searchedElems
        }, () => {
            this.inventorySearchModal.hide();
            this.loadListingTblData(1);
        });
    }

    inventorySearchClear = () => {
        this.setState({
            formSearchedElems: [],
            inventorySearchForm: { ...this.initInventorySearchForm },
            submittedInventoryFilterForm: { ...this.initInventorySearchForm },
            searchedItem: [],
        }, () => {
            this.loadListingTblData(1);
            this.setState({ criteriaHeight: 0 });
            this.inventorySearchModal.hide();
        });
    }

    //***********************DOWNLOAD PDF **************************** */
    downloadPdfHandler = (transaction_id, key) => {
        this.setState({ pdfDownloading: true });
        HttpAPICall.withAthorization('GET', ISC_INV_TRANSFER_URL + '/detail/' + transaction_id, this.props.access_token, { download: key }, {}, (response) => {
            download.file(response.data.file_path);
        }).then(() => this.setState({ pdfDownloading: false }));
    }

    downloadItemWiseHandler = (transaction_id) => {
        this.setState({ pdfDownloading: true });
        HttpAPICall.withAthorization('GET', this.inventoryTransferReportUrl, this.props.access_token, { action: "download", search_like_transaction_id: transaction_id }, {}, (response) => {
            download.file(null, response.data.msg, response.data.navigation, this.props);
        }).then(() => this.setState({ pdfDownloading: false }));
    }

    closeViewDetails = () => {
        this.setState({ minimizeTable: false });
    }

    // Update comment - calls the modal's scroll method
    updateComment = () => {
        if (this.inventoryDetailRef.current) {
            this.inventoryDetailRef.current.scrollToComment();
        }
    }

    // Open edit screen
    openUpdateInventoryScreen = () => {
        if (this.state.inventoryDetail) {
            this.props.history.push({ 
                pathname: `/inventory_transfer_list/add`, 
                state: { inventoryTransferData: this.state.inventoryDetail } 
            });
        }
    }

    // Delete - calls the modal's delete method
    deleteInventoryTransfer = (transaction_id) => {
        if (this.inventoryDetailRef.current) {
            this.inventoryDetailRef.current.deleteInventoryTransfer(transaction_id);
        }
    }

    // Add to Consumption - calls the modal's method
    addToConsumptionModalInit = () => {
        if (this.inventoryDetailRef.current) {
            this.inventoryDetailRef.current.addToConsumptionModalInit();
        }
    }

    // Add to Allocation - calls the modal's method
    addToAllocationModalInit = () => {
        if (this.inventoryDetailRef.current) {
            this.inventoryDetailRef.current.addToAllocationModalInit();
        }
    }

    // Link to Indent - calls the modal's method
    linkToIndentInit = () => {
        if (this.inventoryDetailRef.current) {
            this.inventoryDetailRef.current.linkToIndentInit();
        }
    }

    inventoryTransferListjsx = () => {
        return (<Ax>
            <div className="page_title row m0">
                <div className={this.state.minimizeTable ? "col-3" : "col-12"}>
                    <h3>Inventory Transfer</h3>
                    <div className="text-end mt15">
                        {(!this.state.minimizeTable) ? 
                            <button type="button" disabled={!this.props.permissions.includes('isc-inventory_transfer-add')} className="btn btn-primary" onClick={this.openAddInventoryTransferScreen}>New Inventory Transfer</button> : null}
                        <button type="button" className="btn btn-secondary" onClick={this.inventorySearchModalInit} disabled={this.state.listing_loading}>
                            <tapIcon.imageIcon icon={tapIcon.SearchIcon} className="img-fluid" alt="item-action" />
                        </button>
                        {this.state.minimizeTable && this.props.permissions.includes('isc-inventory_transfer-add') ? 
                            <span className="dropdown">
                                <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary">
                                    <tapIcon.imageIcon icon={tapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    <li><a className="dropdown-item" href="" onClick={this.openAddInventoryTransferScreen}>New Inventory Transfer</a></li>
                                </ul>
                            </span> : null}
                    </div>
                </div>
                {this.state.minimizeTable ? (
                    <div className="col-9 tap_border_left">
                        <h3>Inventory Transfer: {this.state.inventoryItemId}</h3>
                        <div className="text-end mt15">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                disabled={this.state.detail_loading}
                                onClick={() => this.updateComment()}>Update Status</button>
                            <button
                                disabled={this.state.pdfDownloading || this.state.detail_loading}
                                type="button" data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary">
                                <tapIcon.FontAwesomeIcon icon={tapIcon.faDownload} />
                                {this.state.pdfDownloading && <tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin ms-2" />}
                            </button>
                            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
                                <li>
                                    <a className="dropdown-item" disabled={this.state.detail_loading} onClick={() => this.downloadPdfHandler(this.state.inventoryItemId, 'download')}>Download</a>
                                </li>
                                <li>
                                    <a className="dropdown-item" disabled={this.state.detail_loading} onClick={() => this.downloadPdfHandler(this.state.inventoryItemId, 'gatepass')}>Download Gatepass</a>
                                </li>
                                <li>
                                    <a className={['dropdown-item', (this.state.detail_loading) ? 'disabled' : ''].join(' ')} onClick={() => this.downloadItemWiseHandler(this.state.inventoryItemId)}>Item Wise Download</a>
                                </li>
                                  <li>
                                        <a href='#' className={['dropdown-item', (this.state.detail_loading) ? 'disabled' : ''].join(' ')} onClick={() => this.downloadPdfHandler(this.state.inventoryItemId, 'download_delivery_challan')}>Download Delivery Challan</a>
                                    </li>
                            </ul>
                            <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary">
                                <tapIcon.imageIcon icon={tapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li>
                                    <a className={['dropdown-item', (this.state.detail_loading || this.state.inventoryDetail?.can_edit == 'N' || !this.props.permissions.includes('isc-inventory_transfer-edit')) ? 'disabled' : ''].join(' ')} onClick={() => this.openUpdateInventoryScreen()}>Edit</a>
                                </li>
                                <li>
                                    <a className={['dropdown-item', (this.state.detail_loading || this.state.inventoryDetail?.can_delete == "N" || !this.props.permissions.includes('isc-inventory_transfer-delete')) ? 'disabled' : ''].join(' ')} onClick={() => this.deleteInventoryTransfer(this.state.inventoryItemId)}>Delete</a>
                                </li>
                                <li>
                                    <button className={['dropdown-item', (this.state.detail_loading || this.state.inventoryDetail?.status !== 36 || !this.props.permissions.includes('isc-consumption-add')) ? 'disabled' : ''].join(' ')} onClick={() => this.addToConsumptionModalInit()}>Add To Consumption</button>
                                </li>
                                <li>
                                    <button className={['dropdown-item', (this.state.detail_loading || this.state.inventoryDetail?.status !== 36 || !this.props.permissions.includes('isc-allocation-add')) ? 'disabled' : ''].join(' ')} onClick={() => this.addToAllocationModalInit()}>Add To Allocation</button>
                                </li>
                                <li>
                                    <a className={['dropdown-item', (this.state.detail_loading || this.state.inventoryDetail?.status !== 36) ? 'disabled' : ''].join(' ')} onClick={() => this.linkToIndentInit()}>Adjust Item Against Approved Indent</a>
                                </li>
                            </ul>
                            <button type="button" className="btn btn-secondary" onClick={this.closeViewDetails}>
                                <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                            </button>
                        </div>
                    </div>
                ) : null}
            </div>
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div className={['pageTbl', this.state.minimizeTable ? 'col-3' : 'col-12'].join(' ')}>
                        {this.inventoryTransferListingTableJsx()}
                    </div>
                    {this.state.minimizeTable ? 
                        <div className="col-9 pr4 pl4">
                            <div className="bg-white p-2" style={{ height: "100%" }}>
                                {this.inventoryTransferViewDetails()}
                            </div>
                        </div> : null}
                </div>
            </div>
        </Ax>);
    }

    inventoryTransferListingTableJsx = () => {
        return (<Ax>
            <div ref={this.criteriaRef} style={{ position: 'sticky', top: 0, background: 'white' }}>
                <DisplaySearchCriteria searchedElems={this.state.formSearchedElems} onClearFilter={this.inventorySearchClear} />
            </div>
            <table className="table table-bordered bg-white">
                <thead className="table-secondary" style={{ top: `${this.state.criteriaHeight}px`, position: 'sticky' }}>
                    {this.state.minimizeTable ? (
                        <tr>
                            <th scope="col" style={{ width: "15%" }}>Transfer Order ID (Date)</th>
                        </tr>
                    ) : (
                        <tr className='text-center'>
                            <th scope="col" style={{ width: "5%" }}>S.No</th>
                            <th scope="col" style={{ width: "10%" }}>Date</th>
                            <th scope="col" style={{ width: "12%" }}>Transfer Order ID</th>
                            <th scope="col" style={{ width: "21%" }} className='text-start'>Dispatching Warehouse</th>
                            <th scope="col" style={{ width: "20%" }} className='text-start'>Receiving Warehouse</th>
                            <th scope="col" style={{ width: "8%" }} className='text-end'>Total Quantity</th>
                            <th scope="col" style={{ width: "8%" }} className='text-end'>Amount</th>
                            <th scope="col" style={{ width: "10%" }}>Status</th>
                            <th scope="col" style={{ width: "5%" }}>Action</th>
                        </tr>
                    )}
                </thead>
                <tbody>
                    {this.state.listing_loading ? (
                        <tr><td colSpan="8"><Loader /></td></tr>
                    ) : (this.state.inventory_listing.length > 0 ? (
                        this.state.inventory_listing.map((item, index) => {
                            return (<tr key={index}>
                                {this.state.minimizeTable ? (
                                    <Ax>
                                        <td>
                                            <a role="button" className="link-primary" onClick={() => this.viewInventoryTransferDetail(item.transaction_id)}>{item.transaction_id}</a>
                                            <br /><small>{item.transaction_date_display}</small>
                                            <small style={{ float: 'right' }}><Status color={item.status_color}>{item.status_text}</Status></small>
                                        </td>
                                    </Ax>
                                ) : (
                                    <Ax>
                                        <td>{this.state.listingMeta ? this.state.listingMeta.from + index : index}</td>
                                        <td className='text-center'>{item.transaction_date_display}</td>
                                        <td className='text-center'><a role="button" className="link-primary text-center" onClick={() => this.viewInventoryTransferDetail(item.transaction_id)}>{item.transaction_id}</a></td>
                                        <td>{item.warehouse_from_data ? item.warehouse_from_data.name : '-'}</td>
                                        <td className='text-capitalize'>{item.warehouse_to_data ? item.warehouse_to_data.name : "-"}</td>
                                        <td className="text-end">{parseInt(item.total_qty)}</td>
                                        <td className="text-end"><CurrencyFormatter currencyCode={this.props.default_currency} amount={parseFloat(item.total_amount ? item.total_amount : 0).toFixed(2)} /></td>
                                        <td className='text-center'><Status color={item.status_color}>{item.status_text}</Status></td>
                                        <td className="text-center">
                                            <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn">
                                                <tapIcon.FontAwesomeIcon icon={tapIcon.faEllipsisV} />
                                            </button>
                                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                <li><a className="dropdown-item" role="button" onClick={() => this.viewInventoryTransferDetail(item.transaction_id)}>View</a></li>
                                            </ul>
                                        </td>
                                    </Ax>
                                )}
                            </tr>);
                        })
                    ) : (
                        <tr><td colSpan="9" className="text-center">No Records</td></tr>
                    ))}
                </tbody>
            </table>
            <DisplayListPagination
                meta={this.state.listingMeta}
                onPageChange={(e) => this.loadListingTblData(e.selected + 1)}
            />
        </Ax>);
    }

    inventoryTransferViewDetails = () => {
        return (
            <div className="tab_content_header">
                <InventoryTransferDetail
                    ref={this.inventoryDetailRef}
                    renderAs="inline"
                    transaction_id={this.state.inventoryItemId}
                    history={this.props.history}
                    onDetailLoaded={(data) => {
                        this.setState({ inventoryDetail: data, detail_loading: false });
                    }}
                    onUpdate={() => {
                        this.loadListingTblData(this.state.listing_tbl_page);
                    }}
                    onDelete={() => {
                        this.setState({ minimizeTable: false });
                        this.loadListingTblData(1);
                    }}
                />
            </div>
        );
    }

    //***********************SEARCH INVENTORY JSX****************
    inventorySearchModalJsx = () => {
        return (
            <div className="modal fade" id="inventorySearchModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchInventoryModalLabel">Inventory Transfer Search</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form id="inventorySearchForm" onSubmit={this.submitInventorySearchForm}>
                            <div className="modal-body">
                                <div className="row my-3 align-items-center">
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Transaction ID</label>
                                    <div className="col-sm-4">
                                        <input
                                            name="search_like_transaction_id"
                                            type="text"
                                            value={this.state.inventorySearchForm.search_like_transaction_id}
                                            className="form-control"
                                            autoComplete="off"
                                            onChange={(e) => this.formInputHandler(e, "inventorySearchForm")}
                                            placeholder="Please enter Transaction ID"
                                            style={{ height: "30px", fontSize: "93%" }}
                                        />
                                    </div>
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Eway Bill Number</label>
                                    <div className="col-sm-4">
                                        <input
                                            name="search_eway_number"
                                            type="text"
                                            value={this.state.inventorySearchForm.search_eway_number}
                                            className="form-control"
                                            autoComplete="off"
                                            onChange={(e) => this.formInputHandler(e, "inventorySearchForm")}
                                            placeholder="Please enter Eway Bill Number"
                                            style={{ height: "30px", fontSize: "93%" }}
                                        />
                                    </div>
                                </div>
                                <div className="row my-3 align-items-center">
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Invoice Number</label>
                                    <div className="col-sm-4">
                                        <input
                                            name="search_invoice_number"
                                            type="text"
                                            value={this.state.inventorySearchForm.search_invoice_number}
                                            className="form-control"
                                            autoComplete="off"
                                            onChange={(e) => this.formInputHandler(e, "inventorySearchForm")}
                                            placeholder="Please enter Invoice Number"
                                            style={{ height: "30px", fontSize: "93%" }}
                                        />
                                    </div>
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Batch Number</label>
                                    <div className="col-sm-4">
                                        <input
                                            name="search_item_batch_number"
                                            type="text"
                                            value={this.state.inventorySearchForm.search_item_batch_number}
                                            className="form-control"
                                            autoComplete="off"
                                            onChange={(e) => this.formInputHandler(e, "inventorySearchForm")}
                                            placeholder="Item Batch Number"
                                            style={{ height: "30px", fontSize: "93%" }}
                                        />
                                    </div>
                                </div>
                                <div className="row my-3 align-items-center">
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Dispatching Warehouse</label>
                                    <div className="col-sm-10">
                                        <TapSelect
                                            options={this.state.allDispatchingWarehouses}
                                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'inventorySearchForm', 'search_warehouse_from_ids')}
                                            value={this.state.allDispatchingWarehouses.filter(u => this.state.inventorySearchForm?.search_warehouse_from_ids?.includes(u.value))}
                                            isSearchable={true}
                                            isMulti={true}
                                            isClearable={true}
                                            placeholder="Select Dispatching Warehouses"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>
                                <div className="row my-3 align-items-center">
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Receiving Warehouse</label>
                                    <div className="col-sm-10">
                                        <TapSelect
                                            options={this.state.allReceivingWarehouses}
                                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'inventorySearchForm', 'search_warehouse_to_ids')}
                                            value={this.state.allReceivingWarehouses.filter(u => this.state.inventorySearchForm?.search_warehouse_to_ids?.includes(u.value))}
                                            isSearchable={true}
                                            isMulti={true}
                                            isClearable={true}
                                            placeholder="Select Receiving Warehouses"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>
                                <div className="row my-3 align-items-center">
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Item</label>
                                    <div className="col-sm-10">
                                        <InputItemSearch
                                            placeholder="Search Item"
                                            isMulti={true}
                                            changeEvent={(selectedOption) => {
                                                this.tapSelectChange(selectedOption, 'inventorySearchForm', 'search_item_ids');
                                                this.setState({
                                                    searchedItem: selectedOption ? selectedOption : null
                                                });
                                            }}
                                            containerHeight="30px"
                                            fontSize="93%"
                                            value={this.state.searchedItem.length > 0 ? this.state.searchedItem.map(a => { a.label = a.display_label; return a; }) : []}
                                        />
                                    </div>
                                </div>
                                <div className="row my-3 align-items-center">
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Item Tags</label>
                                    <div className="col-sm-10">
                                        <TapSelect
                                            options={this.state.allItemTags}
                                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'inventorySearchForm', 'search_item_tags')}
                                            value={this.state.allItemTags.filter(u => this.state.inventorySearchForm?.search_item_tags?.includes(u.value))}
                                            isSearchable={true}
                                            isMulti={true}
                                            isClearable={true}
                                            placeholder="Select Item Tags"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>
                                <div className="row my-3 align-items-center">
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Status</label>
                                    <div className="col-sm-10">
                                        <TapSelect
                                            options={this.state.allStatusOptions}
                                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'inventorySearchForm', 'search_status_ids')}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={this.state.allStatusOptions.filter(s => this.state.inventorySearchForm.search_status_ids.includes(s.value))}
                                            placeholder="Select Status"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>
                                <div className="row my-3 align-items-center">
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Transaction Period</label>
                                    <div className="col-sm-10">
                                        <PeriodSelectionWithCustom
                                            periods={this.state.all_periods ? this.state.all_periods : []}
                                            value={this.state.inventorySearchForm.date_range}
                                            startDate={this.state.inventorySearchForm.date_range_start}
                                            endDate={this.state.inventorySearchForm.date_range_end}
                                            onSelectPeriod={(period, startDate, endDate) => {
                                                this.setState({
                                                    inventorySearchForm: {
                                                        ...this.state.inventorySearchForm,
                                                        date_range: period,
                                                        date_range_start: startDate ? startDate : null,
                                                        date_range_end: endDate ? endDate : null
                                                    }
                                                });
                                            }}
                                            className="form-control-sm"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                                <button type="submit" className="btn btn-primary">Search</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }

    // formInputHandler = (e, formName) => {
    //     this.setState({
    //         [formName]: {
    //             ...this.state[formName],
    //             [e.target.name]: e.target.value
    //         }
    //     });
    // }

    // tapSelectChange = (selectedOption, formName, fieldName) => {
    //     this.setState({
    //         [formName]: {
    //             ...this.state[formName],
    //             [fieldName]: selectedOption ? selectedOption.value : ''
    //         }
    //     });
    // }

    render = () => {
        return (<ApplicationLayout>
            <Helmet><title>Inventory Transfer Listing</title></Helmet>
            {this.inventoryTransferListjsx()}
            {this.inventorySearchModalJsx()}
        </ApplicationLayout>);
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token,
        all_warehouses: state.app && state.app.warehouses ? state.app.warehouses : [],
        all_periods: state.app && state.app.all_periods ? state.app.all_periods : [],
        item_tags: state.app && state.app.item_tags ? state.app.item_tags : [],
        isc_configuration: state.app && state.app.isc_configuration ? state.app.isc_configuration : null,
        default_currency: state.app && state.app.default_currency ? state.app.default_currency : 'INR',
        permissions: state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : []
    };
};

export default connect(mapStateToProps)(InventoryTransferList);